import { render, staticRenderFns } from "./ChildPageHeader.vue?vue&type=template&id=707997da&scoped=true&"
import script from "./ChildPageHeader.vue?vue&type=script&lang=js&"
export * from "./ChildPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChildPageHeader.vue?vue&type=style&index=0&id=707997da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707997da",
  null
  
)

export default component.exports